import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { ICardGameState } from './interfaces';
import api from '../../lib/api';
import { AppState } from '..';
import { IGameCard } from '../../types';

const initialState: ICardGameState = {
  loading: false,
  gameCard: null,
  gameCards: [],
};

export const gamesSlice = createSlice({
  name: 'games',
  initialState,
  reducers: {},
  extraReducers: builder =>
    builder
      // создание карточки игры
      .addCase(createGameCard.pending, state => {
        state.loading = true;
      })
      .addCase(createGameCard.fulfilled, (state, { payload }) => {
        const { data } = payload;
        state.gameCard = data;
        state.loading = false;
      })
      .addCase(createGameCard.rejected, state => {
        state.loading = false;
      })
      // редактирование карточки игры
      .addCase(editGameCard.pending, state => {
        state.loading = true;
      })
      .addCase(editGameCard.fulfilled, (state, {}) => {
        state.loading = false;
      })
      .addCase(editGameCard.rejected, state => {
        state.loading = false;
      })
      // получени списка карточек игр
      .addCase(fetchCardsGame.pending, state => {
        state.loading = true;
      })
      .addCase(fetchCardsGame.fulfilled, (state, { payload }) => {
        const { data } = payload;
        state.gameCards = data;
        state.loading = false;
      })
      .addCase(fetchCardsGame.rejected, state => {
        state.loading = false;
      })
      // получени карточки игры
      .addCase(fetchCardGame.pending, state => {
        state.loading = true;
      })
      .addCase(fetchCardGame.fulfilled, (state, { payload }) => {
        const { data } = payload;
        state.gameCard = data;
        state.loading = false;
      })
      .addCase(fetchCardGame.rejected, state => {
        state.loading = false;
      }),
});

// ------------------------------------ THUNKS ------------------------------------ //

// создание карточки игры
export const createGameCard = createAsyncThunk<any, any, any>(
  'games/createGameCard',
  async (params, thunkApi) => {
    try {
      console.log('games/createGameCard: params', params);
      const response = await api.game.createCard(params);
      return { data: response };
    } catch (err) {
      console.log('createGameCard err', err);
      return thunkApi.rejectWithValue({ err });
    }
  },
);

// редактирование карточки игры
export const editGameCard = createAsyncThunk<any, any, any>(
  'games/editGameCard',
  async (params, thunkApi) => {
    try {
      const response = await api.game.editCard(params, params._id);
      return { data: response };
    } catch (err) {
      console.log('editGameCard err', err);
      return thunkApi.rejectWithValue({ err });
    }
  },
);

// получени списка карточек игр
export const fetchCardsGame = createAsyncThunk<any, any, any>(
  'games/fetchCardsGame',
  async (_, thunkApi) => {
    try {
      const response = await api.game.list();
      return { data: response };
    } catch (err) {
      console.log('fetchCardsGame err', err);
      return thunkApi.rejectWithValue({ err });
    }
  },
);

// удаление карточки игры
export const deleteGameCard = async (id: string) => {
  try {
    await api.game.delete(id);
  } catch (e) {
    return e.response.status;
  }
};

// получени карточки игры
export const fetchCardGame = createAsyncThunk<any, any, any>(
  'games/fetchCardGame',
  async (id, thunkApi) => {
    try {
      const response = await api.game.item(id);
      return { data: response };
    } catch (err) {
      console.log('fetchCardGame err', err);
      return thunkApi.rejectWithValue({ err });
    }
  },
);

export const {} = gamesSlice.actions;

export const selectGameState = (state: AppState) => state.gamesReducer;

export default gamesSlice.reducer;
